import { LocaleType } from '../types/locale';

// Add supported languages' locale to the array
export const supportedLanguages: LocaleType[] = [LocaleType.ENGLISH_US];
